/**
 * Removes the slug part from a path
 */
export function deslug<T extends `/@/:slug${string}`>(path: T): T extends `/@/:slug${infer Rest}` ? Rest : never {
  return path.replace("/@/:slug", "") as any;
}
